import {Col, Container, Image, Row} from "react-bootstrap";
import {createUseStyles} from "react-jss";
import {Link} from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import {useEffect} from "react";
import {NotificationManager} from "react-notifications";

const categories = [
    [{
        id:1,
        name:'ศูนย์พัฒนาการบริการทางวิชาชีพเภสัชกรรม',
        img:'01.jpg'
    },
    {
        id:2,
        name:'สำนักงานรับรองคุณภาพร้านยา',
        img:'02.jpg'
    }],
  [  {
        id:3,
        name:'วิทยาลัยเภสัชบำบัดแห่งประเทศไทย',
        img:'03.jpg'
    },
    {
        id:4,
        name:'วิทยาลัยการคุ้มครองผู้บริโภคด้านยาและสุขภาพแห่งประเทศไทย',
        img:'04.jpg'
    },
    {
        id:8,
        name:'วิทยาลัยเภสัชกรรมสมุนไพรแห่งประเทศไทย',
        img:'08.jpg'
    }],
    [{
        id:5,
        name:'วิทยาลัยเภสัชกรรมอุตสาหการแห่งประเทศไทย',
        img:'05.jpg'
    },
    {
        id:6,
        name:'วิทยาลัยการบริหารเภสัชกิจแห่งประเทศไทย',
        img:'06.jpg'
    },
    {
        id:7,
        name:'วิทยาลัยเภสัชกรรมชุมชนแห่งประเทศไทย',
        img:'07.jpg'
    },
    {
        id:9,
        name:'ราชวิทยาลัยเภสัชกรรมแห่งประเทศไทย',
        img:'09.jpg'
    }],

];

const useStyles = createUseStyles({
    category: {
        textDecoration:'none',
        cursor:'pointer',
        '& img':{
           '&:hover':{
               filter: 'brightness(1.1)',
               boxShadow: '#5b5a5a 1px 1px 5px',
               transition:'all 0.3s',
           }
        }
    }
});

const LandingPage = () => {
    const classes = useStyles();
    let [searchParams, setSearchParams] = useSearchParams();
    useEffect(() => {
       if(searchParams.get('denied')){
           NotificationManager.error('Access denied.');
       }
    }, []);

    return <Container>
            <div className="p-4">
                {categories.map((cols,k)=>
                    <Row key={k} className="justify-content-center">
                        {cols.map(cat=>
                            <Col key={cat.id} lg={4} className="text-center p-2">
                                <a href={`/course/index.php?categoryid=${cat.id}`} className={classes.category}>
                                    <div>
                                        <Image fluid src={`categories_img/${cat.img}`}/>
                                    </div>
                                </a>
                            </Col>
                        )}
                    </Row>
                )}
            </div>
        <div className="text-center pb-5 alert alert-info">
            <h3>คู่มือการใช้งาน</h3>
            <Row className="justify-content-center">
                <Col>
                    <a target='_blank' className="me-2" href='/oauth2/LMS_Manual_V1.pdf'>คู่มือการใช้งานระบบ</a>
                    |
                    <a target='_blank' className="ms-2" href='/oauth2/reset_password.png'>การลงทะเบียนเข้าใช้งาน</a>
                </Col>
            </Row>
        </div>
    </Container>
}

export default LandingPage;